<template>
  <div class="report-container">
    <div class="report-area">
      <h1>Sensor Report</h1>

      <div v-if="reportLoading">Loading...</div>


      <div v-else class="table-container">
        <table>
          <tr>
            <td>Sensor Name:</td>
            <td>{{ this.report.sensor.name }}</td>
          </tr>
          <tr>
            <td>Time Frame:</td>
            <td>{{ this.report.period }} starting {{ new Date(this.report.periodStartTimestamp * 1000).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' }).replace(/\//g, '-') }}
            </td>
          </tr>
          <tr>
            <td>High Temp Events:</td>
            <td>{{ this.report.highTemps }} over {{ this.report.sensor.high }}°F</td>
          </tr>
          <tr>
            <td>Low Temp Events:</td>
            <td>{{ this.report.lowTemps }} under {{ this.report.sensor.low }}°F</td>
          </tr>
        </table>
      </div>

      <div class="chart-container">
        <div v-if="chartLoading">
          <p>Loading Sensor Data...</p>
        </div>
        <Chart class="chart" v-if="!chartLoading" ref="chart" :chart-data="chartdata" :options="otherOptions"/>
      </div>
    </div>


  </div>
</template>

<script>

import Chart from "@/components/Chart.vue";
import moment from "moment";

export default {
  name: "ReportPage",
  props: [],
  components: {
    Chart

  },
  data() {
    // console.log('report', );
    return {
      reportLoading: true,
      chartLoading: true,
      report: null,
      sensorUuid: this.$route.params.id,
      periodStartTimestamp: this.$route.params.periodStartTimestamp,

      currentData: [],

      chartLow1: 33,
      chartLow2: 30,
      chartHigh1: 41,
      chartHigh2: 44,

      colors: [
        "#13293D",
        "#006494",
        "#247BA0",
        "#1B98E0",
        "#21897E",
        "#3BA99C",
        "#554971",
        "#63768D",
        "#F08700",
        "#AD5D4E",
        "#353535",
        "#561F37",
        "#72195A",
      ],

      otherOptions: {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          intersect: false,
        },
        scales: {
          xAxes: [
            {
              type: "time",
              time: {
                unit: "hour",
                tooltipFormat: "MMM D, h:mm a",
                stepSize: 24,
                displayFormats: {
                  hour: "MM/DD"
                },
              },
              ticks: {
                maxTicksLimit: 14,
                min: this.report ? new Date(this.report.periodStartTimestamp * 1000).toISOString() : new Date().toISOString()
              }
            },
          ],
          yAxes: [
            {
              ticks: {
                // suggestedMin: 30,
                // suggestedMax: 40,
                // min: 30,
                // max: 50,
                // stepSize: 2
              },
            },
          ],
        },
        legend: {
          display: false,
        },
      },
    };
  },
  computed: {
    high() {
      return Math.max(
        ...[].concat(
          ...this.currentData.map((item) => {
            return Object.values(item).filter(
              (item2) => typeof item2 === "number"
            );
          })
        )
      );
    },
    low() {
      return Math.min(
        ...[].concat(
          ...this.currentData.map((item) => {
            return Object.values(item).filter(
              (item2) => typeof item2 === "number"
            );
          })
        )
      );
    },
  },
  async mounted() {
    // console.log('Calling getSensorReport: ', this.sensorId, this.periodStartTimestamp)
    const result = await this.$store.dispatch("sensor/getSensorReport", {
      sensorUuid: this.sensorUuid,
      periodStartTimestamp: this.periodStartTimestamp
    });
    this.report = result;

    this.otherOptions.scales.xAxes[0].ticks.min = moment(this.report.periodStartTimestamp * 1000).startOf('day').toDate().toISOString();

    this.reportLoading = false;

    let readings = await this.$store.dispatch("sensor/pullReadings", {
      id: this.report.sensor.id,
      from: new Date(this.report.periodStartTimestamp * 1000),
      to: moment(this.report.periodStartTimestamp * 1000).add(1, this.report.period).toDate()
    });


    this.chartLow1 = this.report.sensor.low
        ? this.report.sensor.low + 2
        : -97;
      this.chartLow2 = this.report.sensor.low ? this.report.sensor.low : -100;
      this.chartHigh1 = this.report.sensor.high
        ? this.report.sensor.high - 2
        : 97;
      this.chartHigh2 = this.report.sensor.high ? this.report.sensor.high : 100;

    // console.log('Chart gradient stops: ', this.chartLow1, this.chartLow2, this.chartHigh1, this.chartHigh2);
    // console.log('Readings: ', readings)

    // readings = readings.slice(0, 100);

    this.currentData = readings;

    const values = ['min'];
    const allData = values.map((item, i, arr) => ({
      name: item,
      readings: this.currentData.map((cur) => ({
          createdAt: cur.createdAt,
          [item]: cur[item],
        })),
    }));

    // console.log('allData: ', allData);

    this.chartdata = {
      datasets: allData.map((item, i) => {
        return {
          label: `${item.name === "min" ? "temp" : item.name}`,
          borderColor: (context) => {
            if (item.name !== "min") {
              return this.colors[i];
            } else {
              return this.chartGradient(context);
            }
          },
          backgroundColor: (context) => {
            if (item.name !== "min") {
              return this.colors[i];
            } else {
              return this.chartGradient(context);
            }
          },
          radius: 0,
          borderWidth: 2,
          fill: false,
          data: item.readings.map((item2) => {
            return {
              x: new Date(item2.createdAt),
              y: item2[item.name],
            };
          }),
        };
      })
    };

    // console.log('set chartData: ', this.chartdata);

    this.chartLoading = false;

  },
  // watch: {
  //   otherOptions: {
  //     handler(val) {
  //       if (this.$refs.chart) {
  //         console.log('renderChart', this.chartdata, this.otherOptions)
  //         this.$refs.chart.renderChart(
  //           this.chartdata,
  //           this.otherOptions
  //           // this.deviceType === "KDX" ? this.kdxOptions : this.otherOptions
  //         );
  //       }
  //     },
  //     deep: true,
  //   },
  // },
  methods: {
    chartGradient(context) {
      let gradient = null;
      let width = null;
      let height = null;
      let chartArea = context.chart.chartArea;
      if (!chartArea) {
        return null;
      }
      let chartWidth = chartArea.right - chartArea.left;
      let chartHeight = chartArea.bottom - chartArea.top;
      if (gradient === null || width !== chartWidth || height !== chartHeight) {
        width = chartWidth;
        height = chartHeight;
        let ctx = context.chart.ctx;
        gradient = ctx.createLinearGradient(
          0,
          chartArea.bottom,
          0,
          chartArea.top
        );

        let colors = this.colorStop();
        colors.forEach((item) => {
          gradient.addColorStop(item.value, item.color);
        });
      }
      return gradient;
    },

    colorStop(val) {
      let vals = [];

      // green
      if (this.high < this.chartHigh1) {
        vals.push({
          color: "green",
          value: 0,
        });
      }
      // yellow
      else if (this.low >= this.chartHigh1 && this.high <= this.chartHigh2) {
        vals.push({
          color: "#d8d300",
          value: 0,
        });
      }
      // red
      else if (this.low > this.chartHigh2) {
        vals.push({
          color: "red",
          value: 0,
        });
      }
      // green, yellow and red
      else if (this.low < this.chartHigh1 && this.high >= this.chartHigh2) {
        vals.push(
          {
            color: "green",
            value: 0,
          },
          {
            color: "#d8d300",
            value:
              Math.abs(this.low - this.chartHigh1) / (this.high - this.low),
          },
          {
            color: "red",
            value:
              Math.abs(this.low - this.chartHigh2) / (this.high - this.low),
          }
        );
      }
      // green and yellow
      else if (
        this.low < this.chartHigh1 &&
        this.high >= this.chartHigh1 &&
        this.high < this.chartHigh2
      ) {
        vals.push(
          {
            color: "green",
            value: 0,
          },
          {
            color: "#d8d300",
            value:
              Math.abs(this.low - this.chartHigh1) / (this.high - this.low),
          }
        );
      }
      // yellow and red
      else if (this.low >= this.chartHigh1 && this.high >= this.chartHigh2) {
        vals.push(
          {
            color: "#d8d300",
            value: 0,
          },
          {
            color: "red",
            value:
              Math.abs(this.low - this.chartHigh2) / (this.high - this.low),
          }
        );
      }

      return vals;
    },


    
  },
};
</script>

<style>
div.report-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
div.report-area {

  width: 75%;
}
div.chart-container {
  padding-top: 24px;
  padding-bottom: 24px;
  border-left: 1px solid #ddd;
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
}
.chart {
  margin-left: 24px;
  margin-right: 24px;
}
div.table-container {
  margin-top: 24px;
}

div.table-container table {
  width: 100%;
  border-collapse: collapse;
}
div.table-container p {
    padding: 12px;
  }

  div.table-container th, div.table-container td {
  padding: 18px;
  text-align: left;
  border: 1px solid #ddd;
}

div.table-container tr:nth-child(even) {
  background-color: #f2f2f2;
}
</style>
